import * as React from "react";
import { io, Socket } from "socket.io-client";

export const SocketContext = React.createContext<Socket>({} as Socket);
const ENDPOINT = process.env.REACT_APP_SOCKET_URL;

export const SocketContextProvider: React.FunctionComponent = ({
  children,
}) => {
  if (!ENDPOINT) {
    throw new Error("src/socket URL missing.");
  }

  const [socket] = React.useState<Socket>(
    io(ENDPOINT, {
      transports: ["websocket"],
    })
  );

  React.useEffect(
    () => () => {
      socket.disconnect();
    },
    [socket]
  );

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
